import "./transaccion.css";
import React, { useEffect, useState } from "react";
import confirmado from "../../../img/confirmado.svg";
import {
  actualizarVendido,
  addCompra,
  addNotification,
  addVenta,
  consultarProyecto,
  getCompra,
  getVenta,
} from "../../../firebaseConfig";
import { Link, useParams } from "react-router-dom";
import { useUsuario } from "../../../context/UserContext";

function Transaccion() {
  const { id, email, address1, area1, country, uid } = useParams();
  const [usuarios, setUsuarios] = useState([]);
  const [volver, setVolver] = useState(false);
  const {obtenerUsers} = useUsuario();

  useEffect(() => {
    obtenerUsers().then((array) => {
      setUsuarios(array);
    });
    obtenerDatos();
  }, []);

  async function obtenerDatos() {
    await consultarProyecto(id).then((res) => {
      let details = {
        amount: {
          currency_code: "USD",
          value: res.datos.precio,
        },
        payee: {
          email_address: email,
        },
        payment_instruction: {
          disbursement_mode: "INSTANT",
          platform_fees: [
            {
              amount: {
                currency_code: "USD",
                value: (5 * res.datos.precio) / 100,
              },
            },
          ],
        },
        shipping: {
          address: {
            address_line_1: address1,
            admin_area_1: area1,
            country_code: country,
          },
        },
      };

      guardarVenta(details, uid, res);
      guardarCompra(details, uid, res);
    });
  }

  function verUser(uid) {
    let user = {uid: '',displayName:''};
    for (let i = 0; i < usuarios.length; i++) {
      if (uid === usuarios[i].UID) return {
        uid: uid,
        displayName: usuarios[i].Nombre
      };
    }
    return user;
  }
  
  async function guardarVenta(details, usuario, proyecto) {
    try {
      actualizarVendido(proyecto.id);
      let venta = [];
      let fecha = ''+new Date();
      await getVenta(proyecto.datos.uid_creador)
        .then((res) => {
          console.log(res);
          venta = res;
        })
        .catch((e) => console.log(e));
      venta.push({
        proyecto: proyecto,
        entregado: false,
        comprador: details,
        comprador_uid: usuario,
        fecha: fecha,
      });
      await addVenta(venta, proyecto.datos.uid_creador).catch((e) =>
        console.log(e)
      );
      console.log("addVenta");
      let user = verUser(usuario)
      addNotification(id, "Comprado", user);
      setVolver(true);
    } catch (error) {
      console.log(error);
      setVolver(false)
    }
  }

  async function guardarCompra(details, usuario, proyecto) {
    try {
      let compra = [];
      let fecha = ''+new Date();
      await getCompra(usuario).then((res) => {
        compra = res;
      });
      compra.push({
        proyecto: proyecto,
        entregado: false,
        comprador: details,
        comprador_uid: usuario,
        fecha: fecha,
      });
      await addCompra(compra, usuario);
      setVolver(true);
      console.log("addCompra");
    } catch (error) {
      console.log(error);
      setVolver(false);
    }
  }

  return (
    <div className="body">
      {volver ? (
        <div>
          <svg
            className="logo"
            width="420"
            height="103"
            viewBox="0 0 470 183"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44.3529 0.937747C44.3529 1.35578 44.8647 1.77381 45.5471 1.77381C46.9118 1.77381 48.9588 4.61644 49.8118 7.62627C50.1529 8.79678 51.3471 11.9738 52.4559 14.7328C63.8853 43.4099 64.2265 44.5804 61.1559 46.4197C59.8765 47.1722 59.1941 46.8378 57.3176 44.5804C56.0382 43.0755 53.8206 39.6476 52.5412 37.0558C51.1765 34.464 48.7882 30.2001 47.1676 27.6083C45.6324 25.0164 44.3529 22.1738 44.3529 21.2542C44.3529 19.164 42.05 15.9869 40.4294 15.9869C38.5529 15.9869 38.9794 17.3246 42.4765 21.8394C44.2676 24.1804 47.7647 30.1165 50.2382 35.0492C52.7118 39.982 55.1 44.664 55.5265 45.5001C57.1471 48.4263 55.6118 47.841 52.0294 44.246C50.0676 42.2394 48.8735 41.4033 49.3 42.323C49.8118 43.2427 51.0059 44.7476 51.9441 45.5837C52.9676 46.5033 53.7353 47.9246 53.7353 48.7607C53.7353 51.0181 51.5176 54.9476 49.8118 55.6165C47.6794 56.3689 39.7471 50.0148 35.5676 44.246C32.2412 39.6476 30.7059 38.3935 30.7059 40.2328C30.7059 40.7345 34.3735 44.7476 38.8088 49.1787C43.5 53.7771 46.9118 57.7902 46.7412 58.5427C46.3147 60.5492 42.3059 60.6328 38.2118 58.5427C33.7765 56.3689 28.5735 52.3558 21.8353 45.9181C19.1059 43.2427 16.3765 41.3197 15.95 41.6542C15.3529 41.9886 16.2059 43.0755 17.8265 44.3296C19.3618 45.5001 23.6265 48.9279 27.2941 51.9378C36.7618 59.7968 38.6382 61.1345 39.8324 61.1345C41.3676 61.1345 42.2206 65.064 40.9412 66.5689C40.3441 67.2378 39.5765 67.5722 39.15 67.3214C38.7235 67.0705 38.3824 67.2378 38.3824 67.7394C38.3824 68.1574 38.8088 68.8263 39.3206 69.1607C40.9412 70.0804 38.2971 71.1673 34.2882 71.1673C27.1235 71.1673 8.7 65.2312 4.09412 61.3017C2.55882 60.0476 0 60.4656 0 61.8869C0 62.305 1.45 63.141 3.24118 63.6427C4.94706 64.2279 9.12647 65.7328 12.3676 66.9869C15.6941 68.241 19.7029 69.5788 21.3235 70.0804C31.9853 73.0902 34.9706 74.1771 35.3971 75.1804C35.5676 75.7656 35.3118 76.4345 34.6294 76.6853C32.9235 77.3542 16.8882 72.923 15.0118 71.2509C13.6471 70.164 13.4765 70.164 13.8176 71.1673C13.9882 71.8361 16.9735 73.2574 20.5559 74.3443C24.0529 75.4312 28.5735 77.0197 30.7059 77.9394C32.8382 78.7755 35.4824 79.6115 36.6765 79.6951C38.5529 79.946 38.8088 80.2804 38.6382 82.8722C38.2971 87.8053 38.9794 89.3938 42.2206 90.3971C43.8412 90.8988 45.4618 91.902 45.8029 92.4873C46.2294 93.0725 48.3618 95.4971 50.5794 97.8381C54.6735 102.018 54.6735 102.018 59.5353 101.768L64.3971 101.517L64.9941 98.2561C65.9324 92.9889 65.7618 92.0692 63.4588 89.8119C62.1794 88.6414 61.2412 86.802 61.2412 85.8824C61.4118 83.2902 62.1794 77.605 62.4353 77.5214C62.6059 77.5214 64.0559 76.1837 65.7618 74.6787C67.3823 73.1738 69.6853 71.8361 70.7088 71.5853C73.0971 71.1673 75.2294 69.5787 74.6324 68.6591C74.3765 68.3246 75.0588 66.9869 75.9971 65.8165C77.5323 63.8935 78.0441 63.7263 79.0676 64.646C79.8353 65.2312 81.7971 65.7328 83.5029 65.8165C85.2088 65.9001 88.1088 66.5689 89.9853 67.405C91.8618 68.1574 94.4206 68.9099 95.7 68.9935C96.8941 68.9935 97.7471 69.3279 97.4912 69.6624C96.7235 71.0001 98.6853 70.2476 99.9647 68.8263C102.438 65.9837 102.438 64.4787 99.9647 63.4755C98.6853 62.8902 97.5765 62.3886 97.4059 62.305C96.8941 62.0542 100.05 54.864 101.329 53.4427C102.012 52.6902 105.082 51.1853 108.238 50.2656C111.309 49.2624 114.379 48.2591 115.062 48.0919C115.744 47.9246 116 47.5066 115.744 47.2558C115.488 47.005 112.076 47.9246 108.238 49.2624C97.6618 52.8574 95.6147 53.1083 90.7529 51.1017C88.5353 50.0984 84.6971 48.9279 82.3088 48.4263C80.0059 48.0083 77.1912 47.0886 76.0824 46.4197C75.0588 45.7509 73.7794 45.4165 73.4382 45.6673C72.4147 46.2525 69.0882 42.0722 69.0882 40.3164C69.0882 38.1427 64.9088 30.9525 60.9 26.2705C58.2559 23.2607 57.1471 21.2542 57.1471 19.4984C57.1471 16.1542 55.7824 12.7263 53.4794 10.1345C52.4559 8.96399 50.8353 6.7066 49.9823 5.11807C47.7647 1.10496 44.3529 -1.48684 44.3529 0.937747Z"
              fill="#C1121F"
            />
            <path
              d="M45.1206 35.8017C45.5471 36.6377 46.4853 38.0591 47.253 38.9787C48.4471 40.4836 48.4471 40.4 47.5941 37.4738C47.0824 35.8017 46.0588 34.3804 45.4618 34.3804C44.6088 34.3804 44.5236 34.7984 45.1206 35.8017Z"
              fill="#C1121F"
            />
            <path
              d="M100.234 107.373C105.174 111.2 105.409 113.387 105.409 147.007V182.267H111.289C116.935 182.267 117.17 181.72 117.17 163.133V144H128.931C135.517 144 140.692 142.633 140.692 141.267C140.692 139.627 135.517 138.533 128.931 138.533H117.17V123.5V108.467H127.284C138.34 108.467 140.927 110.107 144.926 118.033C147.513 123.227 147.513 123.227 147.748 116.393C147.748 104.913 143.985 103 118.581 103C96.4704 103 95.2943 103.273 100.234 107.373Z"
              fill="white"
            />
            <path
              d="M291.938 107.92C294.291 110.653 295.937 116.12 295.937 120.22C295.937 126.78 295.231 127.053 287.94 125.686C278.06 123.773 271.239 128.146 266.299 139.08C258.302 157.393 267.711 182.266 283 182.266C286.999 182.266 291.468 180.9 293.115 178.986C295.231 176.526 296.643 176.526 298.76 178.986C306.522 188.006 307.698 183.086 307.698 144.273C307.698 103.273 307.698 103 294.291 103C288.41 103 288.41 103.273 291.938 107.92ZM295.467 148.1C296.408 170.24 294.761 176.8 288.175 176.8C279.942 176.8 277.12 171.606 277.12 155.48C277.12 136.62 280.177 129.786 288.41 130.88C294.526 131.7 294.761 132.52 295.467 148.1Z"
              fill="white"
            />
            <path
              d="M349.097 105.187C348.156 107.1 334.278 143.453 323.928 170.513C321.576 177.073 320.635 182.267 321.811 182.267C323.223 182.267 325.81 177.347 327.927 171.333L331.691 160.4H346.509C360.387 160.4 361.328 160.673 363.916 168.327C366.974 176.527 374.971 182.267 383.439 182.267C388.143 182.267 388.143 181.993 382.733 175.98C379.676 172.7 371.913 154.933 365.327 136.347C354.272 104.64 351.92 100.267 349.097 105.187ZM352.39 137.44C354.977 144.547 357.094 151.107 357.094 152.473C357.094 153.84 352.39 154.933 346.509 154.933C340.629 154.933 335.925 153.84 335.925 152.2C335.925 149.467 345.804 124.867 346.98 124.867C347.215 124.867 349.567 130.607 352.39 137.44Z"
              fill="#C1121F"
            />
            <path
              d="M444.596 111.747C442.95 113.66 441.774 117.76 441.774 121.04C441.774 124.32 440.362 127.873 438.951 128.42C436.599 129.513 436.599 130.06 438.951 130.06C440.833 130.333 441.774 136.347 441.774 150.287C441.774 174.34 445.537 182.267 456.592 182.267C460.826 182.267 465.766 180.9 467.648 179.533C470.235 177.62 469.294 176.8 463.649 176.8H455.887V156.3C455.887 145.093 455.652 134.98 455.416 133.613C454.946 132.52 457.063 131.427 460.121 130.88C466.942 129.787 466.942 125.687 460.121 125.96C455.416 126.233 454.711 125.14 455.416 117.213C456.122 110.107 455.416 108.467 451.888 108.467C449.301 108.467 446.243 109.833 444.596 111.747Z"
              fill="#C1121F"
            />
            <path
              d="M164.919 127.6C158.804 130.606 152.453 143.726 152.453 153.566C152.453 162.86 158.333 175.98 163.979 179.533C171.27 183.906 184.443 182.813 190.323 177.073C193.381 174.066 195.263 171.06 194.322 169.966C193.381 168.873 191.029 169.966 188.912 172.426C179.974 182.54 166.566 175.433 166.566 160.673C166.566 155.48 167.977 154.933 181.855 154.933C196.674 154.933 197.145 154.66 197.145 147.826C197.145 137.986 185.384 124.866 176.68 125.14C173.152 125.14 167.742 126.233 164.919 127.6ZM181.62 134.706C182.326 137.166 183.031 142.086 183.031 145.64C183.031 151.38 181.855 152.2 174.799 152.2C167.272 152.2 166.566 151.38 166.566 144.546C166.566 140.446 167.742 135.526 169.389 133.613C173.387 128.966 179.974 129.513 181.62 134.706Z"
              fill="white"
            />
            <path
              d="M215.727 132.793C200.908 150.013 210.552 182.267 230.546 182.267C238.779 182.267 248.893 175.98 248.893 170.787C248.893 169.147 247.011 169.693 244.894 172.153C236.897 180.08 227.018 179.26 223.489 169.967C218.079 156.3 219.491 154.933 235.956 154.933C250.54 154.933 251.245 154.66 251.245 148.373C251.245 137.987 248.893 133.067 241.601 128.967C231.487 122.68 223.489 124.047 215.727 132.793ZM237.603 136.893C241.366 146.733 238.543 152.2 230.075 152.2C221.608 152.2 219.491 147.827 222.784 137.713C225.842 128.147 233.839 127.873 237.603 136.893Z"
              fill="white"
            />
            <path
              d="M390.025 126.78C390.025 127.327 391.672 129.787 393.553 131.973C396.141 134.98 397.082 142.36 397.082 159.307C397.082 181.993 397.082 182.267 402.962 182.267C408.608 182.267 408.608 181.72 409.313 158.213L410.019 134.433H418.722C428.601 134.433 430.953 131.153 424.838 126.507C421.78 124.32 418.722 124.593 413.782 126.78C409.313 128.693 403.433 128.967 398.258 127.6C393.789 126.507 390.025 125.96 390.025 126.78Z"
              fill="#C1121F"
            />
          </svg>
          <div className="centro">
            <h1>¡Compra realizada con éxito!</h1>
            <Link className="a" to={"/project/"+id}>
              Volver a FeedArt
            </Link>
          </div>
          <img className="foto" src={confirmado} alt="" />
        </div>
      ) : (
        <div className="text-center pt-5">
          <div className="lds-hourglass"></div>
        </div>
      )}
    </div>
  );
}

export default Transaccion;
